
import Vue from 'vue';
import ConfirmDialog from '@/components/base/ConfirmDialog.vue';

export default Vue.extend({
	name: 'DocumentReadyDialog',
	props: {
		value: { type: Boolean, default: false },
		title: { type: String, default: 'Document Ready' },
		icon: { type: String, default: 'mdi-printer-outline' },
		message: { type: String, default: 'Open the file to download or print' },
		confirmText: { type: String, default: 'Open File' },
	},
	components: {
		ConfirmDialog,
	},
});
